import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { beforeItems, afterItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" aria-labelledby="beforeafter-title" data-id="element-122" data-mp="26mmawj50yzj7">
      <div className="mx-auto max-w-5xl" data-id="element-123" data-mp="22iodccvclws9">
        <div id="beforeafter-title" data-id="element-124" data-mp="2zbjt6m98kwby">
          <SectionHeading title={<>
                From a menopause visit full of questions…
                <span className="mt-1 block text-rose" data-id="element-126" data-mp="2ua48wwevutum">
                  to a 5-step clinical process you can follow.
                </span>
              </>} data-id="element-125" data-mp="2zai8dq2f4vh1" />
        </div>

        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-127" data-mp="2ldd7e4hkamsn">
          <p data-id="element-128" data-mp="19w3kt934zen4">The problem isn’t that menopause information doesn’t exist. There is plenty of it.</p>
          <p data-id="element-129" data-mp="175cn458rchk4">
            The problem is that it’s spread across guidelines, papers, recommendations, and
            different clinical resources.
          </p>
          <p className="font-semibold text-navy" data-id="element-130" data-mp="1c3xdze24dovw">
            When your patient is sitting in front of you, you don’t need another 200-page textbook.
            You need a process.
          </p>
        </div>

        <div className="mt-10 grid gap-5 lg:grid-cols-2" data-id="element-131" data-mp="131xwylr3uksy">
          <div className="rounded-3xl border border-navy/10 bg-white p-5 sm:p-7" data-id="element-132" data-mp="oemhw9vpsio3">
            <p className="inline-flex items-center gap-2 rounded-full bg-navy/[0.06] px-3 py-1.5 text-[12px] font-extrabold uppercase tracking-[0.1em] text-navy/70" data-id="element-133" data-mp="t64ll5p4gxcr">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-134" data-mp="fc3m29qcj6bc" />
              Before
            </p>
            <ul className="mt-5 space-y-4" data-id="element-135" data-mp="jdfcghh1nvkl">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-136" data-mp="5i3hqa2w253o">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy/10 text-navy/60" aria-hidden="true" data-id="element-137" data-mp="afd7jqu6wis1">
                    <XIcon className="h-3 w-3" data-id="element-138" data-mp="27cr6praoymur" />
                  </span>
                  <span className="text-[14.5px] leading-snug text-navy/70 sm:text-[15.5px]" data-id="element-139" data-mp="23bfrmfpg1k0t">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-teal/30 bg-teal-mist p-5 sm:p-7" data-id="element-140" data-mp="2v3eqb9tyz0x5">
            <p className="inline-flex items-center gap-2 rounded-full bg-teal px-3 py-1.5 text-[12px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-141" data-mp="2r107gpqaw15v">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="2m4jjpwn0jotb" />
              With 5-MIN MENOPAUSE™
            </p>
            <ul className="mt-5 space-y-4" data-id="element-143" data-mp="1an0czua853q0">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-144" data-mp="15o6xxxfah4nq">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal text-white" aria-hidden="true" data-id="element-145" data-mp="15nffloapd3fe">
                    <CheckIcon className="h-3 w-3" data-id="element-146" data-mp="10jv0izma2scs" />
                  </span>
                  <span className="text-[14.5px] font-medium leading-snug text-navy sm:text-[15.5px]" data-id="element-147" data-mp="15hern042qzm5">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-148" data-mp="1eahxonce4a6r">
          <CtaButton label="I want the 5-Min Method" subtext="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-149" data-mp="1j9bccj3ey78i" />
        </div>
      </div>
    </section>;
}